module.exports = __webpack_public_path__ + "img/ar39_samurai01skin_shop.32852793.png";